import axios from "@/axios";
import Util from "@/util/util";
export const namespaced = true;

const defaultData = {
  orderId: null,
  currencyId: null,
  exchangeRate: null,
  notToExceed: null,
  transactionSummary: null,
  agreedReturnDate: null,
};

export const state = {
  transactionInformation: Object.assign({}, defaultData),
  status: false,
  agreedDateEnabled: false,
  transactionInformationErrors: []
};

export const getters = {
  transactionInformation: (state) => {
    return state.transactionInformation;
  },

  transactionInformationStatus: (state) => {
    return state.status;
  },
  agreedDateEnabled: (state) => {
    return state.agreedDateEnabled;
  },
  transactionInformationErrors: (state) => {
    return state.transactionInformationErrors;
  }
};

export const mutations = {
  SET_TRANSACTION_INFORMATION(state, response) {
    state.transactionInformation = Object.assign({}, defaultData, response.data)
    state.transactionInformation.agreedReturnDate = response.data.agreedReturnDate;
  },
  SET_STATUS(state, value) {
    state.status = value;
  },
  SET_AGREED_DATE_ENABLED(state, value) {
    state.agreedDateEnabled = value;
  },
  CLEAR_DATA(state) {
    state.transactionInformation = Object.assign({}, defaultData)
  },
  SET_ERRORS(state, data) {
    state.transactionInformationErrors = data;
  },
  CLEAR_ERRORS(state) {
      state.transactionInformationErrors = [];
  }
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },
  async getTransactionInformationStatus({ commit }, id) {
    if (id == 0) {
        commit("SET_STATUS", false)
    } else {
        return await axios.get('/api/transactioninformation/status/' + id)
            .then(({ data }) => {
              if(data && data.length === 0) {
                commit("SET_STATUS", true);
                commit("CLEAR_ERRORS");
            } else {
                commit("SET_STATUS", false);
                commit("SET_ERRORS", data);
            }
            })
    }
  },
  async getAgreedReturnDateEnabled({ commit }, id) {
    if (id == 0) {
      commit("SET_AGREED_DATE_ENABLED", false)
    } else {
        return await axios.get('/api/transactioninformation/agreedstatus/' + id)
            .then(({ data }) => {
                commit("SET_AGREED_DATE_ENABLED", data);
            })
    }
  },
  async getTransactionInformation({ commit }, id) {
    commit("SET_TRANSACTION_INFORMATION", await axios.get(`/api/transactioninformation/${id}`));
  },
  async saveTransactionInformation({ commit, state }, orderId) {
    state.transactionInformation.orderId = orderId;
    state.transactionInformation.agreedReturnDate = Util.convertToDateOnly(state.transactionInformation.agreedReturnDate)
    return await axios.post("/api/transactioninformation/", state.transactionInformation)
  }
};
